var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8022 9.41309V13.9201H17.8457L22.9257 9.41309H15.8022Z",
    fill: "#D4B45C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4487 1L9.94189 4.99818V8.05531H14.4487V1Z",
    fill: "#D4B45C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07876 9.41309L1 13.9177L9.94343 13.9196L9.94408 22.8605L14.4487 18.8653V9.41309H6.07876Z",
    fill: "#00448D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/현대차증권-24.09d0b10accb0fc53ad8c2ad0dc62b333.svg";
export { ForwardRef as ReactComponent };